import sectionreview from '../images/frontend/1-section-review.png'
import nft from '../images/frontend/2-nft.png'
import huddle from '../images/frontend/3-huddle.png'
import sunnyside from '../images/frontend/4-sunnyside.png'
import faq from '../images/frontend/5-faq.png'
import validation from '../images/frontend/6-validation.png'
import card from '../images/frontend/7-card.png'
import rizalport from '../images/uiux/rizal-port.png'

const images = [
    {
        id: 1,
        src: rizalport,
        title: "Rizal's Portfolio",
        description: 'portfolio website to show all the projects I have created',
        tools: 'TailwindCSS, Javascript, React JS, Vercel, Framer Motion',
        liveSite: 'https://rizalportfolio.vercel.app/',
    },

    {
        id: 2,
        src: nft,
        title: 'NFT Card Component',
        description: 'A frontend coding challenge from Frontendmentor to help improve coding skills by building realistic projects',
        tools: 'HTML, CSS, Sass, Netlify',
        liveSite: 'https://nft-preview-cardcomponent.netlify.app/',
        repository: 'https://github.com/rzlfhh/NFT-preview-card-component',
    },

    {
        id: 3,
        src: huddle,
        title: 'Huddle Landing Page',
        description: 'A frontend coding challenge from Frontendmentor to help improve coding skills by building realistic projects',
        tools: 'React Js, Tailwind CSS, Netlify',
        liveSite: 'https://huddle-landing-page-react-tailwind.netlify.app/',
        repository: 'https://github.com/rzlfhh/Huddle-landing-page-react-tailwind',
    },

    {
        id: 4,
        src: faq,
        title: 'FAQ Accordion Card Section',
        description: 'A frontend coding challenge from Frontendmentor to help improve coding skills by building realistic projects',
        tools: 'HTML, CSS, Sass, Netlify',
        liveSite: 'https://faq-accordion-card-rzlfh.netlify.app/',
        repository: 'https://github.com/rzlfhh/faq-accordion-card',
    },

    {
        id: 5,
        src: validation,
        title: 'Sign up Form Validation',
        description: 'A frontend coding challenge from Frontendmentor to help improve coding skills by building realistic projects',
        tools: 'HTML, CSS, Sass, Javascript, Netlify',
        liveSite: 'https://signup-component-fementor.netlify.app/',
        repository: 'https://github.com/rzlfhh/Signup-component-fementor',
    },

    {
        id: 6,
        src: card,
        title: 'Testimonial Grid Section',
        description: 'A frontend coding challenge from Frontendmentor to help improve coding skills by building realistic projects',
        tools: 'HTML, CSS, Sass, Netlify',
        liveSite: 'https://testimonial-component-fementor.netlify.app/',
        repository: 'https://github.com/rzlfhh/Testimonial-grid-fementor',
    },

    {
        id: 7,
        src: sunnyside,
        title: 'Sunnyside Landing Page',
        description: 'A frontend coding challenge from Frontendmentor to help improve coding skills by building realistic projects',
        tools: 'HTML, CSS, Sass, Javascript, Netlify',
        liveSite: 'https://sunnyside-agency-landing-page-fementor.netlify.app/',
        repository: 'https://github.com/rzlfhh/Sunnyside-agency-landing-page-fementor',
    },

    {
        id: 8,
        src: sectionreview,
        title: 'Social Proof Section',
        description: 'A frontend coding challenge from Frontendmentor to help improve coding skills by building realistic projects',
        tools: 'HTML, CSS, Tailwind Css, Netlify',
        liveSite: 'https://social-proof-section-tailwind.netlify.app/',
        repository: 'https://github.com/rzlfhh/Social-proof-section-Tailwind',
    },


];

export default images;